function rangeToList(start, end) {
  var list = [];
  for (var i = start; i <= end; i++) {
    list.push(i);
  }
  return list;
}

function rangeStringToList(range) {
  var r = range.split("-");
  if (r.length === 1) {
    r.push(r[0]);
  }
  return rangeToList(parseInt(r[0]), parseInt(r[1]));
}

function explodeRanges(formula) {
  var places = rangeStringToList(formula[0]);
  var payout = formula[1];
  return places.map((place) => [place, payout]);
}

function flatten(arrays) {
  return [].concat.apply([], arrays);
}

function percentStringToFloat(percent) {
  return parseFloat(percent) / 100.0;
}

function payoutPerPlace(formula, prizePool) {
  return flatten(formula.trim().split(" ")
    .map((f) => f.split(":"))
    .map(explodeRanges))
    .map(([ place, percent ]) => [ place, percentStringToFloat(percent) * prizePool ]);
}

function tokenPayoutPerPlace(formula) {
  return flatten(formula.trim().split(" ")
    .map((f) => f.split(":"))
    .map(explodeRanges));
}

function totalTokenPrizeDistributionValue(formula, tokenTypes) {
  return tokenPayoutPerPlace(formula).reduce((accum, payout) => {
    var token = tokenTypes.get(parseInt(payout[1]));
    return accum + parseFloat(token.get("value"));
  }, 0.0);
}

export default function payouts(tournament, tokenTypes) {
  var p = {};
  if (!tournament) {
    return p;
  }
  if (tournament.get("points_prize_pool") !== undefined && tournament.get("points_prize_pool") !== null) {
    p = payoutPerPlace(tournament.get("payout_structure"), tournament.get("points_prize_pool")).reduce((accum, payout) => {
      accum[payout[0]] = {
        points: payout[1]
      };
      return accum;
    }, p);
  } else if (tournament.get("dollars_prize_pool") > 0) {
    p = payoutPerPlace(tournament.get("payout_structure"), tournament.get("dollars_prize_pool")).reduce((accum, payout) => {
      accum[payout[0]] = {
        dollars: payout[1]
      };
      return accum;
    }, p);
  }

  if (tournament.get("token_prize_distribution") !== undefined && tournament.get("token_prize_distribution") !== null) {
    p = tokenPayoutPerPlace(tournament.get("token_prize_distribution")).reduce((accum, payout) => {
      var token = tokenTypes.get(parseInt(payout[1]));
      accum[payout[0]] = accum[payout[0]] || {};
      accum[payout[0]].tokenName = token.get("name");
      accum[payout[0]].tokenValue = token.get("value");
      return accum;
    }, p);
  }

  return p;
}

export function hasPayout(ticket) {
  return ticket.get("money_payout") !== "0.00"
    || ticket.get("points_payout") !== 0
    || ticket.get("token_type_payout_id") !== null;
}

export function totalPrize(tournament, tokenTypes) {
  return calculateTotalPrize(tournament.get("dollars_prize_pool"), tournament.get("token_prize_distribution"), tokenTypes);
}

export function maximumTotalPrize(tournament) {
  var maxTotalEntries = tournament.get("money_buy_in_amount") * tournament.get("max_users");
  var maxRake = maxTotalEntries * tournament.get("rake_percent");
  var maxPrize = maxTotalEntries - maxRake;
  if (maxPrize === 0.0) {
    return null;
  }
  return maxPrize;
}

export function totalAlternatePrize(tournament, tokenTypes) {
  return calculateTotalPrize(tournament.get("alternate_prize_pool"), tournament.get("alternate_token_prize_distribution"), tokenTypes);
}

function calculateTotalPrize(dollarsPrizePool, tokenPrizeDistribution, tokenTypes) {
  var total = 0.0;

  if (dollarsPrizePool !== undefined && dollarsPrizePool !== null) {
    total += parseFloat(dollarsPrizePool);
  }

  if (tokenPrizeDistribution !== undefined && tokenPrizeDistribution !== null) {
    total += totalTokenPrizeDistributionValue(tokenPrizeDistribution, tokenTypes);
  }

  if (total === 0.0) {
    return null;
  }
  return total;
}
